module.exports = __webpack_public_path__ + "img/my_team.8d5ad162.png";